module.exports = __webpack_public_path__ + "static/media/U1-T2-1-5.e4e6e79c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-5.svg
// module id = 531
// module chunks = 0